module.exports = __webpack_public_path__ + "img/signal-2.33fb9ecb.svg";